<template>
  <div class="globo-diag" :class="posGlob">
    <div class="diag">
      <slot name="globcont"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    posGlob: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables";

.globo-diag {
  .diag {
    width: 100%;
    max-width: 500px;
    display: table;
    height: 120px;
    padding: 5px;
    border-radius: 7px;
    border: solid;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
    }
    p {
      display: table-cell;
      vertical-align: middle;
    }
  }
}

.application.theme--light {
  &.light {
    .diag {
      border: solid 3px $primary-red;
    }
    .diag-left {
      .diag {
        &:after {
          content: "";
          border-right: 30px solid $primary-red;
        }
      }
    }
    .diag-right {
      .diag {
        &:after {
          content: "";
          border-left: 30px solid $primary-red;
        }
      }
    }
    .top-left,
    .top-right {
      .diag {
        &:after {
          border-top: 30px solid $primary-red;
        }
      }
    }
  }
  &.dark {
    .diag {
      border: solid 3px $secondary-red;
    }
    .diag-left {
      .diag {
        &:after {
          content: "";
          border-right: 30px solid $secondary-red;
        }
      }
    }
    .diag-right {
      .diag {
        &:after {
          content: "";
          border-left: 30px solid $secondary-red;
        }
      }
    }
    .top-left,
    .top-right {
      .diag {
        &:after {
          border-top: 30px solid $secondary-red;
        }
      }
    }
  }
}

@media (min-width: 600px) {
  .diag-left {
    margin-left: 30px;
    .diag {
      &:after {
        content: "";
        bottom: 10px;
        left: -30px;
        border-top: 15px solid transparent;
        border-right: 30px solid red;
        border-bottom: 15px solid transparent;
      }
    }
  }
  .diag-right {
    margin-right: 30px;
    .diag {
      &:after {
        content: "";
        bottom: 10px;
        right: -30px;
        border-top: 15px solid transparent;
        border-left: 30px solid red;
        border-bottom: 15px solid transparent;
      }
    }
  }
  .top-left,
  .top-right {
    margin-bottom: 30px;
    .diag {
      &:after {
        content: "";
        bottom: -30px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 30px solid red;
      }
    }
  }

  .top-left {
    .diag {
      &:after {
        content: "";
        left: 30px;
      }
    }
  }
  .top-right {
    .diag {
      &:after {
        content: "";
        right: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Globodiag.vue?a56c1758